/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePhoneNumberRequest
 */
export interface UpdatePhoneNumberRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePhoneNumberRequest
     */
    phoneNumber: string;
}

/**
 * Check if a given object implements the UpdatePhoneNumberRequest interface.
 */
export function instanceOfUpdatePhoneNumberRequest(value: object): value is UpdatePhoneNumberRequest {
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    return true;
}

export function UpdatePhoneNumberRequestFromJSON(json: any): UpdatePhoneNumberRequest {
    return UpdatePhoneNumberRequestFromJSONTyped(json, false);
}

export function UpdatePhoneNumberRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePhoneNumberRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'phoneNumber': json['phoneNumber'],
    };
}

export function UpdatePhoneNumberRequestToJSON(value?: UpdatePhoneNumberRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'phoneNumber': value['phoneNumber'],
    };
}

